export default "__VITE_ASSET__BARxSm3m__"